import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  HOME_LOAD_COLLECTIONS_BEGIN,
  HOME_LOAD_COLLECTIONS_DISMISS_ERROR,
  HOME_LOAD_COLLECTIONS_FAILURE,
  HOME_LOAD_COLLECTIONS_SUCCESS,
} from './constants';
import axios from 'axios';

export function loadEditorCollections(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_LOAD_COLLECTIONS_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_LOAD_COLLECTIONS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_LOAD_COLLECTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadEditorCollectionsError() {
  return {
    type: HOME_LOAD_COLLECTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_LOAD_COLLECTIONS_BEGIN:
      return {
        ...state,
        loadEditorCollectionsPending: true,
        loadEditorCollectionsError: null,
      };

    case HOME_LOAD_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loadEditorCollectionsPending: false,
        loadEditorCollectionsError: null,
        collections: action.data,
        // selectedCollection: action.data[0]
      };

    case HOME_LOAD_COLLECTIONS_FAILURE:
      return {
        ...state,
        loadEditorCollectionsPending: false,
        loadEditorCollectionsError: action.data.error,
      };

    case HOME_LOAD_COLLECTIONS_DISMISS_ERROR:
      return {
        ...state,
        loadEditorCollectionsError: action.data,
      };

    default:
      return state;
  }
}
